import React from 'react';

import Home from './pages/Home';
import GlobalStyles from './styles/GlobalStyles';

function App() {
  return (
    <>
      <Home />
      <GlobalStyles />
    </>
  );
}

export default App;
